export default __webpack_public_path__ + "static/media/drsukrit.2f934c06.png";